import api from './client'

export interface AppConfig {
  runtime_base_url: string
  /** "beta" (waitlist only) | "production" (open sign-up). */
  release_stage: string
  /** True only in production — gates the Create-account link + /register. */
  signup_enabled: boolean
}

let cached: Promise<AppConfig> | null = null

export function getAppConfig(): Promise<AppConfig> {
  if (!cached) {
    cached = api.get<AppConfig>('/config').then((res) => res.data).catch((err) => {
      cached = null
      throw err
    })
  }
  return cached
}

/** Drop the cache so the next read reflects a just-changed value (e.g. an
 *  instance admin flipping the release stage). */
export function clearAppConfigCache(): void {
  cached = null
}
